import(/* webpackMode: "eager", webpackExports: ["TermlyPolicy","CookiePolicyDataId"] */ "/codebuild/output/src1065581005/src/apps/wrap.gifts/src/services/Termly/TermlyPolicy.tsx");
